(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearControlAgreementNewController", LebaniegoYearControlAgreementNewController);

    LebaniegoYearControlAgreementNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearControlAgreement",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearControlAgreementNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearControlAgreement,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearControlAgreement = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlAgreementParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlAgreement = Object.assign({}, vm.lebaniegoYearControlAgreement);
            lebaniegoYearControlAgreement.id = null;
            lebaniegoYearControlAgreement.year = vm.lebaniegoYearControlAgreement.year;
            lebaniegoYearControlAgreement.sector = 'CONVENIO';
            vm.lebaniegoYearControlAgreement.gFile = {
                id: vm.lebaniegoYearControlAgreement.gFile
            };
            lebaniegoYearControlAgreement.gFile = vm.lebaniegoYearControlAgreement.gFile;
            LebaniegoYearControlAgreement.save(lebaniegoYearControlAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-control-agreement", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el convenio");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlAgreement.gFile = item.gFileId;
            }
        }
    }
})();